<template>
  <b-container>
    <LoadingIndicator 
      v-if="loading"
      topic="User"
    />
    <b-row>
      <b-col>
        <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      </b-col>
    </b-row>
    <div v-if="!loading && showUser">
      <b-row class="mb-4">
      </b-row>
      <b-row class="text-left">
        <b-col cols="1"></b-col>
        <b-col cols="10">
          <h1 style="float:left;">{{user.name}}</h1>
          <b-button
            v-if="delible"
            @click="confirmDelete"
            title="Delete User"
            v-b-tooltip.hover
            variant="danger"
            style="width: 60px;">
            <font-awesome-icon :icon="['far', 'trash-alt']" size ="2x"></font-awesome-icon>
          </b-button>
            <b-button 
              class="float-right"
              variant="primary"
              to="/user/list">
              Back to list
            </b-button>
        </b-col>
        <b-col cols="1"></b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
        <b-col cols="10">
          <strong>Job Title: </strong>{{user.jobTitle}}<br />
          <strong>Email: </strong>{{user.email}}<br/>
          <strong>Mobile Phone: </strong>{{user.phone ? user.phone : 'None'}}<br/>
          <strong>Password status: </strong>{{status}}
          <b-button
            v-if="status === 'NoPassword'"
            :disabled="sendingInvite || inviteSent"
            @click="resendInvite"
            variant="warning"
            size="sm"
            style= "width: 90px;">
            <b-spinner v-if="sendingInvite" small label="Spinning" ></b-spinner>
            <font-awesome-icon v-else-if="inviteSent" :icon="['fas', 'check']" size="1x"></font-awesome-icon>
            <div v-else>Send invite</div>
          </b-button><br/>
          <strong>System Admin: </strong>{{admin ? "Yes" : "No"}} <br/>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row class="text-left">
        <b-col></b-col>
        <b-col cols="10" class="mt-4">
          <h2 style="margin-bottom:20px">Projects</h2>
          <b-table hover responsive 
              class="custom-table"
            :items="projectListItems" 
            :fields="projectListFields" 
              @row-clicked="openProject">
              <template v-slot:cell(status)="data">
                <div class="lvl">
                  <span>{{data.item.status}}</span>
                </div>
              </template>
            <template v-slot:cell(permissionLevel)="data">
              <b-badge v-if="data.item.permissionLevel === 'Sponsor'" variant="primary">
                Executive
              </b-badge>
              <b-badge v-else-if="data.item.permissionLevel  === 'Admin'" variant="danger">
                Admin
              </b-badge>
              <b-badge v-else-if="data.item.permissionLevel  === 'Respondent'" variant="warning">
                Respondent
              </b-badge>
            </template>
            <template v-slot:cell(isPrimary)="data">
              <span v-if="data.item.isPrimary">
                <b-icon icon="check2" aria-label="Yes" title="Yes">Yes</b-icon>
              </span>
              <span v-else>
                <b-icon icon="x" aria-label="No" title="No">No</b-icon>
              </span>
            </template>
          </b-table>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <b-modal
      ref="delete-user-modal"
      @ok.prevent="deleteUser"
      ok-variant="danger"
      :ok-disabled="sendingDelete"
      cancel-title="No!"
      cancel-variant="primary"
      centered
      title="Delete Confirmation">
      <p>Are you sure you want to delete this user?</p>
      <BaseMessageBlock :messages="deleteErrors"></BaseMessageBlock>
      <template v-slot:modal-ok >
        <div style="width: 90px;" >
          <b-spinner v-if="sendingDelete" small label="Spinning"/>
          <div v-else>Yes, I'm sure.</div>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import axios from "axios";

export default {
  name: "User",
  components: {

  },
  data() {
    return {
      errors: [],
      deleteErrors: [],
      loading: false,
      inviteSent: false,
      sendingInvite: false,
      sendingDelete: false,
      showUser: false,
      user: null,
      status: '',
      admin: false,
      projects: [],
      createdProjectMetrics: [],
      //assignedProjectMetrics: [], 
      attendedMeetings: [],
      invitations: [],
      projectListItems: [],
      projectListFields: [
        { key: "projectName", label: "Name", sortable: true },
        { key: "status", label: "Status", sortable: true,
          tdClass: (value) => value.toLowerCase().replace(/ /g,'-')  },
        { key: "permissionLevel", label: "Access", sortable: true },
        { key: "isPrimary", label: "Primary?", sortable: true }
      ]
    }
  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    let id = this.$route.params.id;
    if (!id){
      this.$router.push({
        name: 'Home'
      });
    }
    this.loadUser(id);
  },
  methods: {
    buildProjectList(){
      this.projectListItems = this.projects;
      let ord1 = ["Respondent", "Admin", "Sponsor"];
      let ord2 = ["Open", "Closed"];
      this.projectListItems
        .sort((a, b) => a.projectName > b.projectName ? 1 : -1)
        .sort((a, b) => a.isPrimary === b.isPrimary ? 0 : a.isPrimary ? -1 : 1)
        .sort((a, b) => ord1.indexOf(a.permissionLevel) > ord1.indexOf(b.permissionLevel) ? 1 : -1)
        .sort((a, b) => ord2.indexOf(a.status) > ord2.indexOf(b.status) ? 1 : -1)
    },
    loadUser(id) {
      this.loading = true;
      axios
        .get(`${this.$api_url}/users/${id}/summary`, this.getReqConfig())
        .then(response => {
          this.user = response.data.user;
          this.status = response.data.status;
          this.admin = response.data.admin;
          this.projects = response.data.projects;
          this.createdProjectMetrics = response.data.createdProjectMetrics;
          //this.assignedProjectMetrics = response.data.assignedProjectMetrics;
          this.attendedMeetings = response.data.attendedMeetings;
          this.invitations = response.data.invitations;
          this.showUser = true;
          this.buildProjectList();
        })
        .catch(err => {
          if (err.response){
            this.errors.push({ message: err.response.data });
          } else{
            this.errors.push(err);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendInvite() {
      this.sendingInvite = true;
      this.errors = [];
      axios
        .post(`${this.$api_url}/users/${this.user.userId}/send-signup-invite`, null, this.getReqConfig())
        .then(() => {
          this.inviteSent = true;
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sendingInvite = false;
        });    
    },
    confirmDelete() {
      this.$refs['delete-user-modal'].show();
    },
    deleteUser() {
      this.sendingDelete = true;
      this.deleteErrors = [];
      axios
        .post(`${this.$api_url}/users/${this.user.userId}/delete`, undefined,
          this.getReqConfig())
        .then(() => {
          this.$router.push({ name: "User List"});
        })
        .catch(err => {
          this.deleteErrors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sendingDelete = false;
        });
    },
    openProject(item) {
      this.$router.push('/project/' + item.projectId);
    }
  },
  computed: {
    delible() {
      return !(this.attendedMeetings.length > 0 ||
        this.createdProjectMetrics.length > 0 ||
        this.invitations.filter(i => i.hasResponded === true).length > 0);
    }
  }
}
</script>
<style>
td.buttonColumn {
  min-width: 100px !important;
  max-width: 20%;
  width: 100px !important;
}

td.dataColumn {
  min-width: 300px !important;
  max-width: 80%;
  width: 80% !important;
}
</style>